<div class="mart-order-details-title">Order Timeline</div>

<div class="mart-order-details-title" style="font-size: 14px; margin-top: 20px;">Order Processing</div>

<div class="flex-row">
    <div class="mart-order-details-field-name mart-order-details-timeline-col1">Time accepted:</div>
    <div class="mart-order-details-field-val mart-order-details-timeline-col2">{{parent.acceptedAtTimeStr}}</div>
    <div class="mart-order-details-field-val">{{parent.order.AcceptedUserName}}</div>
</div>
<div class="flex-row">
    <div class="mart-order-details-field-name mart-order-details-timeline-col1">Start packing:</div>
    <div class="mart-order-details-field-val mart-order-details-timeline-col2">{{parent.packingStartedAtTimeStr}}</div>
    <div class="mart-order-details-field-val">{{parent.order.PackingUserName}}</div>
</div>
<div class="flex-row">
    <div class="mart-order-details-field-name mart-order-details-timeline-col1">Finished packing:</div>
    <div class="mart-order-details-field-val mart-order-details-timeline-col2">{{parent.readyToDispatchAtTimeStr}}</div>
    <div class="mart-order-details-field-val">{{parent.order.PackingUserName}}</div>
</div>
<div class="flex-row">
    <div class="mart-order-details-field-name mart-order-details-timeline-col1">Dispatch:</div>
    <div class="mart-order-details-field-val mart-order-details-timeline-col2">{{parent.dispatchAtTimeStr}}</div>
    <div class="mart-order-details-field-val">{{parent.order.DispatchUserName}}</div>
</div>
<div class="flex-row">
    <div class="mart-order-details-field-name mart-order-details-timeline-col1">Delivered:</div>
    <div class="mart-order-details-field-val mart-order-details-timeline-col2">{{parent.deliveredAtTimeStr}}</div>
    <div class="mart-order-details-field-val">{{parent.order.DeliveryService}}</div>
</div>
